import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'vp-chip-success',
    templateUrl: './chip-success.component.html',
    styleUrls: ['./chip-success.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ChipSuccessComponent {}
